<template>
  <modal @close-modal="close">
    <div class="initiate-reset-password">
      <h2 class="my-0">Change Your Password</h2>
      <h4 class="font-weight-normal my-1">
        Please enter your email to 4casters to reset your password.
      </h4>
      <div class="row mt-1">
        <div class="form-group form-label-group-floating col-12">
          <input
            id="emailReset"
            v-model="emailReset"
            type="email"
            name="emailReset"
            placeholder="Email"
            class="form-control"
            @keyup="validateEmail"
          />
          <label class="font-weight-normal" for="emailReset">
            Enter your email
          </label>
        </div>
      </div>
      <div class="row justify-content-center mt-4">
        <button :disabled="!validEmail" @click="resetPassword">
          <b v-if="!loading">Send Reset Password Email</b>
          <div v-else class="row justify-content-center align-items-center">
            <Spinner style="margin: 0 !important" />
          </div>
        </button>
      </div>
    </div>
  </modal>
</template>

<script setup>
import { ref } from 'vue';
import { useAPI } from '@/composables/useAPI';

// components
import Modal from '@/components/global/Modal.vue';
import Spinner from '@/components/global/Spinner.vue';

const emit = defineEmits([
  'send-email-success',
  'send-email-fail',
  'close-modal',
]);
const loading = ref(false);
// Reset password
const emailReset = ref('');

async function resetPassword() {
  loading.value = true;
  try {
    const { request } = useAPI('/user/sendPasswordRevokeEmail');
    const response = await request({ email: emailReset.value });

    if (response.sent) {
      emit('send-email-success');
    } else {
      emit('send-email-fail');
    }
  } catch (error) {
    emit('send-email-fail', error.message);
  } finally {
    loading.value = false;
  }
}

// validate proper email
const validEmail = ref(false);
function validateEmail() {
  if (emailReset.value === '' || emailReset.value === null) {
    validEmail.value = false;
  } else if (
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+main.$/.test(emailReset.value)
  ) {
    validEmail.value = false;
  } else {
    validEmail.value = true;
  }
}

// close modal
function close() {
  emit('close-modal');
}
</script>

<style scoped lang="scss">
@use '@/scss/main.scss';

.form-group {
  margin: 0.5rem 0;
}
label {
  margin-top: -8px;
  color: main.$blue-201 !important;
}
.form-details {
  color: main.$grey-2400;
  font-size: main.$font-size-sm;

  &.error {
    color: main.$red-400;
  }
  &.success {
    color: main.$green-500;
  }
}
.initiate-reset-password {
  max-width: 450px;
  background: main.$grey-500;
  padding: 1rem 2rem;
  color: main.$grey-2400;

  &-header {
    border-bottom: 1px solid main.$color-primary;
  }
}
h2 {
  color: main.$color-primary;
}
h4 {
  margin: 0;
  font-size: main.$font-size-base;
  color: main.$blue-1100;
}
h5 {
  color: main.$grey-2600;
}
p {
  margin: 0;
}
input {
  width: 100%;
  font-size: 16px;
}
button {
  padding: 1rem;
  width: 100%;
}
</style>
